import { Reaction, ReactorContext } from '..';

const isFunction = (obj: any): boolean => {
    return !!(obj && obj.constructor && obj.call && obj.apply);
};

export type RouteFunction = (context: any) => any;

const routeTo = function (route: string | RouteFunction): Reaction {
    return (context: ReactorContext, payload: any, state: any) => {
        if (isFunction(route)) {
            context.router.push((route as RouteFunction)({ $route: context.component.$route }));
        } else {
            context.router.push({ name: route as string });
        }
    };
};

export interface ActionResult {
    action: string;
    payload: any;
} 

export type ActionFunction = (context: any) => ActionResult | void;

const action = function (action: string | ActionFunction): Reaction {
    return (context: ReactorContext, payload: any, state: any) => {
        if (isFunction(action)) {
            // call function and (potentially) get an action result 
            const result = (action as ActionFunction)({ context, payload, state });
            if (result) {
                context.store.dispatch(result.action, result.payload);
            }
        } else {
            // redispatch
            context.store.dispatch(action as string, payload);
        }
    };
};


export {
    action,
    routeTo
}
